import { BrowserRouter as Router } from 'react-router-dom';
import Path from './components/Path';


function App() {
  return (
    <div>
    <Router>
    <Path/>
    </Router>
    </div>
  );
}

export default App;
